import {
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { Config } from "../../../config/Config";
import _ from "lodash";
import { RootState } from "../../../app/store";
import WellnessRepository from "../WellnessRepository";

export interface WellnessPsychoView {
  id: number;
  name: string;
  image: string;
  price: number;
  city: string;
  isIndividual: boolean;
  remotelyOrPresenceEnum: string;
  typology: string;
}

export const getWellnessPsychoViewAsync = createAsyncThunk(
  "wellnessPsycho/getWellnessPsychoView",
  async (data: { queryString?: string }) => {
    const wellNessRepository = new WellnessRepository();
    const response = await wellNessRepository.getWellnessPsychoView(
      data?.queryString
    );
    const activityTails = _.get(
      response,
      Config.WELLNESS_PSYCHO_ACTIVITY_TAIL_RESPONSE
    );
    return activityTails;
  }
);

const WellnessPsychoViewAdapter = createEntityAdapter<WellnessPsychoView>({
  selectId: (WellnessPsychoView) => WellnessPsychoView.id,
});

export const wellnessPsychoViewSlice = createSlice({
  name: "wellnessPsychoViews",
  initialState: WellnessPsychoViewAdapter.getInitialState({
    status: "idle",
    reasonCode: "",
  }),
  reducers: {
    activityTailsEmptyState: (state) => {
      WellnessPsychoViewAdapter.setAll(state, []);
      state.reasonCode = "";
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getWellnessPsychoViewAsync.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          WellnessPsychoViewAdapter.setAll(state, action.payload ?? []);
          state.status = "idle";
        }
      )
      .addCase(getWellnessPsychoViewAsync.pending, (state: any) => {
        state.status = "loading";
      })
      .addCase(getWellnessPsychoViewAsync.rejected, (state: any) => {
        state.status = "failed";
        state.reasonCode = "";
      });
  },
});

export const WellnessPsychoViewSelector =
  WellnessPsychoViewAdapter.getSelectors<RootState>(
    (state) => state.wellnessPsychoViews
  );

export const { activityTailsEmptyState } = wellnessPsychoViewSlice.actions;
export const selectWellnessPsychoViewSliceStatus = (state: any) =>
  state.activityTails.status;
export const selectWellnessPsychoViewSliceReasonCode = (state: any) =>
  state.activityTails.reasonCode;

//#endRegion Status

export default wellnessPsychoViewSlice.reducer;
